export const RAID_HP_DECIMAL_DIGITS = 2;

function finiteNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
}

export function truncateRaidHp(value, digits = RAID_HP_DECIMAL_DIGITS) {
  const number = finiteNumber(value);
  const safeDigits = Math.max(0, Math.min(6, Math.trunc(Number(digits) || 0)));
  const factor = 10 ** safeDigits;
  const scaled = number * factor;
  const epsilon = Number.EPSILON * Math.max(1, Math.abs(scaled)) * 4;
  return Math.trunc(scaled + (scaled < 0 ? -epsilon : epsilon)) / factor;
}

export function formatRaidHpNumber(value, {
  minimumFractionDigits = 0,
  maximumFractionDigits = RAID_HP_DECIMAL_DIGITS,
} = {}) {
  const digits = Math.min(RAID_HP_DECIMAL_DIGITS, Math.max(0, Math.trunc(Number(maximumFractionDigits) || 0)));
  const minimum = Math.min(digits, Math.max(0, Math.trunc(Number(minimumFractionDigits) || 0)));
  return truncateRaidHp(value, digits).toLocaleString('ko-KR', {
    minimumFractionDigits: minimum,
    maximumFractionDigits: digits,
  });
}

export function formatRaidHpEok(value, { infinityLabel = '인피니티' } = {}) {
  if (value === null || value === undefined) return infinityLabel;
  return `${formatRaidHpNumber(value)}억`;
}

export function formatRaidHpInput(value) {
  if (value === null || value === undefined || String(value).trim() === '') return '';
  return String(truncateRaidHp(value));
}

export function raidHpValueFromInput(value) {
  if (value === null || value === undefined || String(value).trim() === '') return 0;
  return Math.max(0, truncateRaidHp(value));
}
